import {environment} from '@env/environment';

export interface AppDownloadConfig {
    android?: string;
    ios?: string;
}

// Sin configuración no se ofrecen descargas (por ejemplo, en Cbet).
// Iconos de PrimeIcons incluidos por styles.scss desde node_modules.
export function getAppDownloadLinks(config?: AppDownloadConfig) {
    return [
        {
            platform: 'Android', store: 'Google Play',
            url: config?.android?.trim(),
            icon: 'pi-android',
            ariaLabel: 'Descargar para Android en Google Play (abre una pestaña nueva)'
        },
        {
            platform: 'iOS', store: 'App Store',
            url: config?.ios?.trim(),
            icon: 'pi-apple',
            ariaLabel: 'Descargar para iOS en App Store (abre una pestaña nueva)'
        }
    ].filter(app => !!app.url);
}

export const APP_DOWNLOAD_LINKS = getAppDownloadLinks(
    (environment as {appDownloadLinks?: AppDownloadConfig}).appDownloadLinks
);
